module.exports = __webpack_public_path__ + "static/media/Goondiwindi.2beefb65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Goondiwindi.png
// module id = 625
// module chunks = 0